// extracted by mini-css-extract-plugin
export var container = "_6e-0";
export var fallback = "_6e-5";
export var fallbackIcon = "_6e-6";
export var hidden = "_6e-2";
export var image = "_6e-3";
export var loaded = "_6e-4";
export var placeholder = "_6e-1";